import styled, { css } from 'styled-components';
import { VscClose } from 'react-icons/vsc';

export const Close = styled(VscClose)`
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: ${props => props.margin};
  padding: 15px 10px;
  border-radius: 4px;
  max-width: 100%;

  ${props =>
    props.errorType.error
      ? css`
          background: #ffe7e7;
          border: 2px solid red;

          section.content svg path {
            color: red !important;
          }
        `
      : props.errorType.warning
      ? css`
          background: #fffdec;
          border: 2px solid #ffc107;

          section.content svg path {
            color: #ffc107 !important;
          }
        `
      : css`
          background: #f6ffed;
          border: 2px solid #b7eb8f;

          section.content {
            svg.success {
              width: 40px !important;
            }

            svg path {
              color: #4caf50 !important;
            }
          }
        `}

  .content {
    display: flex;

    svg {
      min-width: 18px;
      width: 18px;
      height: 18px;
    }

    section.close {
      display: flex;
      justify-content: flex-end;

      svg {
        path {
          color: #717171 !important;
        }
      }
    }

    .message {
      padding: 0 10px;

      h1.title {
        margin: -2px 0 2px 0;
        font-size: 18px !important;
        color: #535353 !important;
        font-style: normal;
        font-weight: normal;
        font-family: Roboto;
      }

      h2.description {
        color: #535353 !important;
        font-style: normal;
        font-weight: normal;
        font-family: Roboto;
        max-width: 100%;
        line-height: 1.3;
        margin: 0;
        font-size: 14px !important;

        flex-wrap: wrap;
      }
    }

    p {
      margin: 0 3px 0 0;
      font-weight: 600;
      cursor: pointer;
    }
  }
`;
